export default __webpack_public_path__ + "static/media/CheckInSplash_KeinTermin.31311d25.png";